export default __webpack_public_path__ + "static/media/login_bg.5e6aa50a.png";